// import MadfuWidget from '@/components/installments-widgets/MadfuWidget';
import TabbyWidget from '@/components/installments-widgets/tabby-widget';
import TamaraWidget from '@/components/installments-widgets/tamara-widget';
import { useLocale } from 'next-intl';
import { validateProductPrice } from '@/utils/product';
import MadfuWidget from './MadfuWidget';

// used in pdp page
// used in cart page
function PaymentWidgets({ product, fromPDP = false, cartTotal = 0 }) {
  const locale = useLocale();

  const price = validateProductPrice(product?.prices_with_tax);
  const minvalue = process.env.NEXT_PUBLIC_TAMARA_MIN_VALUE;
  const maxvalue = process.env.NEXT_PUBLIC_TAMARA_MAX_VALUE;
  const total = fromPDP ? price?.original_price : cartTotal;

  return (
    <div className='flex flex-col gap-4 max-md:gap-3.5 max-sm:gap-2'>
      <TabbyWidget locale={locale} price={total} />
      {total >= minvalue && total <= maxvalue && (
        <div className='rounded-lg'>
          <TamaraWidget locale={locale} amount={total} />
        </div>
      )}
      <div className='border-border rounded-lg border'>
        <MadfuWidget locale={locale} total={total} />
      </div>
    </div>
  );
}

export default PaymentWidgets;
